import { PROFILE_HUB_CONTACT_EMAIL } from '../constants/profileHubLinks';
import { PageChrome } from '../components/PageChrome';
import { ProfileHubContactPanel } from '../components/ProfileHubContactPanel';
import { useI18n } from '../i18n';
import styles from './AuthContactPage.module.css';

export type AuthContactPageProps = {
  onBack: () => void;
};

export function AuthContactPage({ onBack }: AuthContactPageProps) {
  const { t } = useI18n();

  return (
    <PageChrome title={t('auth.portal.contactPageTitle')} onBack={onBack}>
      <div className={styles.page}>
        <p className={styles.intro}>{t('auth.portal.contactPageIntro')}</p>
        <div className={styles.panelWrap}>
          <ProfileHubContactPanel email={PROFILE_HUB_CONTACT_EMAIL} />
        </div>
      </div>
    </PageChrome>
  );
}
